<template>
    <div>
        <Loader v-if="loading" :min-height="'100%'"></Loader>

        <div :class="['flex stat-chart cursor-pointer', isDarkMode ? 'theme-dark-mode' : '']">
            <div
                @click="tabActive = 1"
                :class="{ 'flex flex-08 stat-chart-col tab-select pl-4': true, active: tabActive == 1 }"
            >
                <span class="pointer-events-none font-size-12">Users</span>
                <span>{{ average.users.total || 0 }}</span>
                <div class="flex justify-content-normal">
                    <ArrowUpIcon
                        v-if="average.users.currentData > average.users.previousData"
                        class="text-green"
                        size="0.75x"
                    ></ArrowUpIcon>
                    <ArrowDownIcon v-else class="text-red" size=".75x"></ArrowDownIcon>
                    <span class="font-size-10">{{ average.users.diffData }}%</span>
                </div>
            </div>

            <div
                @click="tabActive = 2"
                :class="{ 'flex flex-08 stat-chart-col tab-select': true, active: tabActive == 2 }"
            >
                <span class="font-size-12">Sessions</span>
                <span>{{ average.sessions.total || 0 }}</span>
                <div class="flex justify-content-normal">
                    <ArrowUpIcon
                        v-if="average.sessions.currentData > average.sessions.previousData"
                        class="text-green"
                        size="0.75x"
                    ></ArrowUpIcon>
                    <ArrowDownIcon v-else class="text-red" size=".75x"></ArrowDownIcon>
                    <span class="font-size-10">{{ average.sessions.diffData }}%</span>
                </div>
            </div>

            <div
                @click="tabActive = 3"
                :class="{ 'flex flex-08 stat-chart-col tab-select': true, active: tabActive == 3 }"
            >
                <span class="font-size-12">Bouce Rate</span>
                <span>{{ average.bounceRate.currentData }}</span>
                <div class="flex justify-content-normal">
                    <ArrowUpIcon
                        v-if="average.bounceRate.currentData > average.bounceRate.previousData"
                        class="text-green"
                        size="0.75x"
                    ></ArrowUpIcon>
                    <ArrowDownIcon v-else class="text-red" size=".75x"></ArrowDownIcon>
                    <span class="font-size-10">{{ average.bounceRate.diffData }}%</span>
                </div>
            </div>

            <div
                @click="tabActive = 4"
                :class="{ 'flex flex-1 stat-chart-col tab-select': true, active: tabActive == 4 }"
            >
                <span class="font-size-12">Sessions Duration</span>
                <span>{{ sessionsDuration }}</span>
                <div class="flex justify-content-normal">
                    <ArrowUpIcon
                        v-if="average.sessionsDuration.currentData > average.sessionsDuration.previousData"
                        class="text-green"
                        size="0.75x"
                    ></ArrowUpIcon>
                    <ArrowDownIcon v-else class="text-red" size=".75x"></ArrowDownIcon>
                    <span class="font-size-10">{{ average.sessionsDuration.diffData }}%</span>
                </div>
            </div>
        </div>
        <div style="margin-bottom: -1rem">
            <apexcharts
                :type="chartType"
                :tab-active="tabActive"
                :options="chartOptions"
                :series="series"
                :response-temp="responseTemp"
                height="180px"
            >
            </apexcharts>
        </div>
    </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import { ArrowUpIcon } from 'vue-feather-icons'
import { ArrowDownIcon } from 'vue-feather-icons'
import Loader from '@/components/Loader'

export default {
    name: 'stat',

    components: {
        apexcharts: VueApexCharts,
        ArrowUpIcon,
        ArrowDownIcon,
        Loader
    },

    props: {
        chartType: {
            type: String,
            default: 'line'
        },

        getDay: {
            type: Number,
            default: 0
        },

        googleApi: {
            type: Array,
            default: () => []
        },

        loading: {
            type: Boolean,
            default: true
        },

        responseTemp: {
            type: Array,
            default: () => []
        }
    },

    data: function () {
        return {
            chartOptions: {
                chart: {
                    toolbar: {
                        show: false
                    },
                    animations: {
                        enabled: true,
                        easing: 'easeinout',
                        dynamicAnimation: {
                            speed: 500
                        }
                    },
                    dropShadow: {
                        enabled: true,
                        opacity: 0.1,
                        blur: 5,
                        left: 0,
                        top: 18
                    },
                    zoom: {
                        enabled: false
                    }
                },
                legend: {
                    show: true,
                    labels: {
                        colors: '#FF0F0F'
                    }
                },
                stroke: {
                    curve: 'straight',
                    dashArray: [0, 2]
                },
                grid: {
                    borderColor: '#eee'
                },
                xaxis: {
                    type: 'datetime',
                    labels: {
                        offsetX: 5,
                        format: 'dd MMM'
                    }
                },
                yaxis: {
                    tickAmount: 3,
                    opposite: true,
                    labels: {
                        show: true
                    }
                },
                dataLabels: {
                    enabled: false
                },
                tooltip: {
                    x: {
                        show: false
                    }
                },
                theme: {
                    mode: null
                }
            },
            series: [],
            rawData: {
                rawUsers: [
                    {
                        name: 'Current Users',
                        data: []
                    },
                    {
                        name: 'Previous Users',
                        data: []
                    }
                ],
                rawSessions: [
                    {
                        name: 'Current Sessions',
                        data: []
                    },
                    {
                        name: 'Previous Seestions',
                        data: []
                    }
                ],
                rawBounceRate: [
                    {
                        name: 'Current Bounce Rate',
                        data: []
                    },
                    {
                        name: 'Previous Bounce Rate',
                        data: []
                    }
                ],
                rawSessionsDuration: [
                    {
                        name: 'Current Sessions Duration',
                        data: []
                    },
                    {
                        name: 'Previous Sessions Duration',
                        data: []
                    }
                ]
            },
            tabActive: 1,
            data: [],
            thisYear: {
                users: [],
                sessions: [],
                bounceRate: [],
                sessionsDuration: [],
                totalSession: 0,
                totalUser: 0,
                totalBounceRate: 0,
                totalSessionDuration: 0
            },
            lastYear: {
                users: [],
                sessions: [],
                bounceRate: [],
                sessionsDuration: [],
                totalSession: 0,
                totalUser: 0,
                totalBounceRate: 0,
                totalSessionDuration: 0
            },
            average: {
                users: {
                    currentData: 0,
                    previousData: 0,
                    diffData: 0
                },
                sessions: {
                    currentData: 0,
                    previousData: 0,
                    diffData: 0
                },
                bounceRate: {
                    currentData: 0,
                    previousData: 0,
                    diffData: 0
                },
                sessionsDuration: {
                    currentData: 0,
                    previousData: 0,
                    diffData: 0
                }
            },
            sessionsDuration: 0,
            modes: {
                dark: {
                    color: '#FFFFFF'
                },
                light: {
                    color: '#000000'
                }
            }
        }
    },

    methods: {
        changeMode(value) {
            const style = value === 'dark' ? this.modes.dark.color : this.modes.light.color

            this.chartOptions = {
                ...this.chartOptions,
                ...{
                    theme: {
                        mode: value,
                        palette: 'palette1'
                    },
                    legend: {
                        labels: {
                            colors: style
                        }
                    },
                    xaxis: {
                        ...this.chartOptions.xaxis,
                        labels: {
                            style: {
                                colors: style
                            }
                        }
                    },
                    yaxis: {
                        opposite: true,
                        tickAmount: 3,
                        labels: {
                            style: {
                                colors: style
                            },
                            formatter: val => val.toFixed(2)
                        }
                    },
                    tooltip: {
                        y: {
                            formatter: (val, { w }) => {
                                if (
                                    w.config.series[0] &&
                                    w.config.series[0].name &&
                                    w.config.series[0].name.indexOf('Sessions Duration') > -1
                                ) {
                                    return this.toSecond(val)
                                }

                                if (val % 1 != 0) {
                                    return parseFloat(val).toFixed(2)
                                }

                                return val
                            }
                        }
                    }
                }
            }
        },

        sum(data) {
            return Number(Math.ceil(data.reduce((a, b) => a + b)))
        },

        avg(data) {
            return Number(Math.ceil(data.reduce((a, b) => a + b) / data.length))
        },

        switchTab() {
            let title = ''
            if (this.tabActive === 1) title = 'Users'
            if (this.tabActive === 2) title = 'Sessions'
            if (this.tabActive === 3) title = 'Bounce Rate'
            if (this.tabActive === 4) title = 'Sessions Duration'
            const data = this.setDataForSeries()
            const series = [
                {
                    name: `Current ${title}`,
                    data: data[0]
                },
                {
                    name: `Previous ${title}`,
                    data: data[1]
                }
            ]
            this.series = series
        },

        loopDataWithKeys(arr, keys) {
            let result = []
            const data = arr
            for (let i = 0; i < data.length; i++) {
                data[i].filter(i => result.push([i[keys[0]], i[keys[1]]]))
            }
            const half = Math.ceil(result.length) / 2
            const firstHalf = result.slice(0, half)
            const secondHalf = result.slice(-half)

            return [firstHalf, secondHalf]
        },

        setDataForSeries() {
            // tab active switch current data
            let mapKeys = ['timestamp']
            if (this.tabActive === 1) mapKeys.push('users')
            if (this.tabActive === 2) mapKeys.push('sessions')
            if (this.tabActive === 3) mapKeys.push('bounceRate')
            if (this.tabActive === 4) mapKeys.push('sessionsDuration')
            const response = this.loopDataWithKeys(this.responseTemp, mapKeys)
            return response
        },

        getPercent(currentUser, previousUser) {
            return Number(Math.ceil(((currentUser - previousUser) / currentUser) * 100))
        },

        getAverage(arr) {
            const MAX = Math.max(...arr)
            const MIN = Math.min(...arr)

            return (MAX - MIN) / arr.length
        },

        resetChartData() {
            const defautltData = function () {
                return {
                    users: [],
                    sessions: [],
                    bounceRate: [],
                    sessionsDuration: [],
                    totalSession: 0,
                    totalUser: 0,
                    totalBounceRate: 0,
                    totalSessionDuration: 0
                }
            }

            this.lastYear = defautltData()
            this.thisYear = defautltData()
        },

        getDiff(arr) {
            this.resetChartData()

            for (let i = 0; i < 1; i++) {
                let row = arr[i]
                let row2 = arr[i + 1]
                for (let j = 0; j < row.length; j++) {
                    this.thisYear.users.push(row[j].users)
                    this.thisYear.sessions.push(row[j].sessions)
                    this.thisYear.bounceRate.push(row[j].bounceRate)
                    this.thisYear.sessionsDuration.push(row[j].sessionsDuration)
                    this.thisYear.totalUser = row[j].totalUser
                    this.thisYear.totalSession = row[j].totalSession
                    this.thisYear.totalBounceRate = row[j].totalBounceRate
                    this.thisYear.totalSessionDuration = row[j].totalSessionDuration

                    this.lastYear.users.push(row2[j].users)
                    this.lastYear.sessions.push(row2[j].sessions)
                    this.lastYear.bounceRate.push(row2[j].bounceRate)
                    this.lastYear.sessionsDuration.push(row2[j].sessionsDuration)
                    this.lastYear.totalUser = row2[j].totalUser
                    this.lastYear.totalSession = row2[j].totalSession
                    this.lastYear.totalBounceRate = row2[j].totalBounceRate
                    this.lastYear.totalSessionDuration = row2[j].totalSessionDuration
                }
            }

            this.average = {
                users: {
                    total: this.thisYear.totalUser,
                    currentData: this.thisYear.totalUser,
                    previousData: this.lastYear.totalUser,
                    diffData: this.getPercent(this.thisYear.totalUser, this.lastYear.totalUser)
                },
                sessions: {
                    total: this.thisYear.totalSession,
                    currentData: this.thisYear.totalSession,
                    previousData: this.lastYear.totalSession,
                    diffData: this.getPercent(this.thisYear.totalSession, this.lastYear.totalSession)
                },
                bounceRate: {
                    total: this.thisYear.totalBounceRate,
                    currentData: this.thisYear.totalBounceRate,
                    previousData: this.lastYear.totalBounceRate,
                    diffData: this.getPercent(this.thisYear.totalBounceRate, this.lastYear.totalBounceRate)
                },
                sessionsDuration: {
                    currentData: this.thisYear.totalSessionDuration,
                    previousData: this.avg(this.lastYear.sessionsDuration),
                    diffData: this.getPercent(this.thisYear.totalSessionDuration, this.lastYear.totalSessionDuration)
                }
            }

            const second = this.average.sessionsDuration.currentData

            this.sessionsDuration = this.toSecond(second)
        },

        toSecond(s) {
            return (
                (s - (s %= 60)) / 60 +
                (9 < s ? ' mins' : ' min') +
                ' ' +
                Math.round(s) +
                (Math.round(s) > 0 ? ' sec' : ' sec')
            )
        }
    },

    watch: {
        responseTemp(val) {
            this.getDiff(val)
            this.switchTab()
        },

        tabActive() {
            this.switchTab()
        },

        isDarkMode(val) {
            this.changeMode(val ? 'dark' : 'light')

            this.isDarkmode = val
        }
    },

    computed: {
        isDarkMode() {
            this.changeMode(this.$store.getters.isDarkMode ? 'dark' : 'light')
            return this.$store.getters.isDarkMode
        }
    }
}
</script>

<style lang="scss" scoped>
.flex {
    display: flex;
    justify-content: space-between;
}

.stat-chart {
    justify-content: center;
    flex-direction: row;
    text-align: left;
}

.stat-chart-col {
    justify-content: center;
    flex-direction: column;
    border-top: 1.5px solid #ebecf0;
    padding-top: 0.5rem;
    transition: border-top 0.25s ease-in;

    div,
    span {
        pointer-events: none;
    }

    &:hover {
        background-color: #fafafa;
    }
}

.theme-dark-mode {
    .stat-chart-col {
        &:hover {
            background: #383838;
        }
    }
}

.chart-detail {
    padding: 0.5rem 1.25rem;

    strong {
        font-size: 20px;
        font-weight: bold;
    }

    .chrat-detail-header {
        margin-bottom: 2.5rem;
    }
}

.stat-chart-header {
    text-align: end;
    margin-top: 0.25rem;
    font-size: 25px;

    p {
        margin-right: 0.15rem;
        margin-bottom: 0rem;
    }

    .btn.dropdown-toggle {
        margin-right: 0.5rem;
    }

    .dropdown-toggle::after {
        transition: 0.2s ease-in;
        transform: rotate(90deg);
    }

    .btn-group.show {
        .dropdown-toggle::after {
            transition: 0.2s ease-in;
            transform: rotate(0deg);
        }
    }

    .dropdown-item:active {
        background-color: transparent !important;
        color: black;
    }
}

hr {
    margin-top: 0.2rem;
    margin-bottom: 0.2rem;
}

.flex-08 {
    flex: 0.8;
}

.font-size-10 {
    font-size: 10px;
}

.font-size-12 {
    font-size: 12px;
}

.mr-6 {
    margin-right: 3rem;
}

.tab-select {
    border-color: #ebecf0;
    border-top-width: 1px;

    &.active {
        border-color: rgb(0, 126, 255);
        border-top-width: 4.5px;
    }
}

.justify-content-normal {
    justify-content: normal;
}
</style>
